import { Injectable } from '@angular/core';
import { CanActivate, Route, Router, UrlTree } from '@angular/router';
import { PermissionService } from './permission.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {

  constructor(private permService: PermissionService, private router: Router) {}

  private async getPermission(route: Route): Promise<boolean | UrlTree> {
    const permission = route.data?.permission;
    await this.permService.GetUserPermission();

    const canAccess = {
      dashboard: this.permService.canAccessDashboard(),
      store: this.permService.canAccessStore(),
      stock: this.permService.canAccessStock(),
      condiment: this.permService.canAccessCondiment(),
      pos: this.permService.canAccessPos(),
      employee: this.permService.canAccessEmployee(),
      customer: this.permService.canAccessCustomer(),
      preferences: this.permService.canAccessPreferences(),
      kitchen: this.permService.canAccessKitchenPrinting(),
      miscellaneous: this.permService.canAccessMiscellaneous(),
      reports: this.permService.canAccessReports(),
      settings: this.permService.canAccessSettings(),
      inventory: this.permService.canAccessInventory(),
      agent: this.permService.canAccessAgent(),
      supplier: this.permService.canAccessSupplier(),
      emenu: this.permService.canAccessEmenu(),
      housekeeping: this.permService.canAccessHousekeeping()
    } as any;

    
    if (permission && canAccess[permission]) return true;
    return this.router.createUrlTree(['/management/unauthorized']);

  }

  canActivate(route: Route): Promise<boolean | UrlTree>  {
    
    return this.getPermission(route);
  }

  canLoad(route: Route): Promise<boolean | UrlTree> {
    return this.getPermission(route);
  }
  
}
